import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { SearchParam, UtMatrixDetailList, UtMatrixMasterList } from 'models/ut/UtMatrixList';
import { callApi } from 'utils/ApiUtil';
import { MailSendRequest } from '../../models/admin/Mail';
import { AutoSendEmail } from '../../models/common/AutoSendEmail';
import { UtMatrixMaster } from '../../models/ut/UtMatrix';

export const getUtMatrixMasterList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/getUtMatrixMasterList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<UtMatrixMasterList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as UtMatrixMasterList[];
};

export const getUtMatrixDetailList = async (utmId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/getUtMatrixDetailList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ utmId: utmId }),
  };
  const response: CommonResponse<UtMatrixDetailList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as UtMatrixDetailList[];
};

export const deleteUtMatrixMaster = async (deleteData: UtMatrixMasterList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/deleteUtMatrixMaster`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: deleteData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

export const saveUtMatrixWrtUser = async (saveData: UtMatrixDetailList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/saveUtMatrixWrtUser`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

export const updateUtMatrixMasterAtchFileGrId = async (saveData) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/updateUtMatrixMasterAtchFileGrId`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const saveSendMailInfo = async (saveData: UtMatrixMaster[]) => {
  console.log('saveData', saveData);

  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/sendMailInfo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};
